import React from "react";
import { Button } from "../ui";
import { RouteNames } from "../router";
import { Seo, Title } from "../components";
import { PAGE_SEO } from "../common";

export const NotFoundPage = () => {
  return (
    <>
      <Seo {...PAGE_SEO.notFound} />
      <div className="container container-margin">
        <div className="not-found-content">
          <Title as="h1" title="404 - Page not found" />
          <Button text="Back to home" path={RouteNames.HOME} />
        </div>
      </div>
    </>
  );
};
